import { RouteObject } from 'react-router';

import { NotFoundPageLazy } from './/page.tsx';

import { EAdminRoutes } from '@/services/router/enums';

export const NOT_FOUND_ROUTE: RouteObject = {
    path: EAdminRoutes.NotFoundException,
    element: <NotFoundPageLazy />,
};
